import { useEffect, useState } from "react";

const IncrementViews = () => {
  const [views, setViews] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const incrementViewCount = async () => {
      const hasVisited = localStorage.getItem("hasVisitedSite");

      if (!hasVisited) {
        try {
          const response = await fetch("https://api.greenecobagsusa.com/api/views/increment", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          });

          if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

          const data = await response.json();
          setViews(data.views);
          setLoading(false);

          localStorage.setItem("hasVisitedSite", "true");
          setTimeout(() => localStorage.removeItem("hasVisitedSite"), 24 * 60 * 60 * 1000);
        } catch (error) {
          console.error("Error incrementing view count:", error);
          setError(error.message);
          setLoading(false);
          fetchViews();
        }
      } else {
        fetchViews();
      }
    };

    const fetchViews = async () => {
      try {
        const response = await fetch("https://api.greenecobagsusa.com/api/views", {
          headers: { Accept: "application/json" },
        });

        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

        const data = await response.json();
        setViews(data.views);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching views:", error);
        setError(error.message);
        setLoading(false);
      }
    };

    incrementViewCount();
  }, []);

  return null; // Pas d'affichage dans ce composant
};

export default IncrementViews;
